import type { CSSProperties } from "react";

// Clean, neutral background applied across real FLOW pages.
// Removed the centered illustration (perceived as a large central logo)
// and removed `background-attachment: fixed` which caused janky scrolling on mobile.
export const PAGE_BG_STYLE: CSSProperties = {
  backgroundColor: "hsl(var(--background))",
};
